import z, { ZodType } from 'zod';

export type DeviceResponse = {
	id: number;
	isConnected: boolean;
	name: string;
};

export const deviceResponseSchema: ZodType<DeviceResponse> = z.object({
	id: z.number(),
	isConnected: z.boolean(),
	name: z.string(),
});
